export function isOver28AtEventDate(
  birthDate: string | null | undefined,
  eventDate: string | null | undefined
): boolean {
  if (!birthDate) return false;
  const birth = new Date(birthDate);
  const ref = eventDate ? new Date(eventDate) : new Date();
  let age = ref.getFullYear() - birth.getFullYear();
  const m = ref.getMonth() - birth.getMonth();
  if (m < 0 || (m === 0 && ref.getDate() < birth.getDate())) age--;
  return age > 28;
}
